/* The validation table, kept as JSON in the same shape as the SQL table in db/schema.sql:
 *   { validation_figure: [ ...rows ] }       one row per report, month and line item: the freshly calculated ("new") figure
 *
 * It is a separate document from the approvals database (srs-db.json) and the app only reads it. Where it comes from (first that works):
 *   1. a JSON file on the server: db/srs-validation.json via src/setupProxy.js in development, or the SAML server's data folder
 *   2. the sample bundled with the app (src/demo/db/srs-validation.seed.json)
 *
 * To move to a real database, replace loadValidation() with a call to an API that returns the rows of validation_figure.
 */
import seed from '../demo/db/srs-validation.seed.json';

const ENDPOINT = '/__srs_validation';
const valid = (doc) => !!doc && Array.isArray(doc.validation_figure);
let kind = 'sample';

export async function loadValidation() {
  try {
    const res = await fetch(ENDPOINT);
    if (res && res.ok) {
      const type = (res.headers && res.headers.get && res.headers.get('content-type')) || '';
      if (type.includes('json')) {                         // a static host answers unknown paths with index.html
        const doc = await res.json();
        if (valid(doc)) { kind = 'file'; return doc.validation_figure; }
      }
    }
  } catch { /* no server: use the sample */ }
  kind = 'sample';
  return seed.validation_figure;
}
export const validationLabel = () => (kind === 'file' ? 'a JSON file on the server' : 'the sample data bundled with the app');
